import { MatchHeight } from "@plugins";

if (!window.mobileMedia) {
    const neededSelectors = ["[data-mh='article-link__title']"];

    for (const iterator of neededSelectors) {
        new MatchHeight(iterator);
    }
}
